// src/mockData/controllers.ts

export const CONTROLLERS = [
  {
    id: 'user-001',
    name: 'Sarah Johnson',
    initials: 'SJ',
    email: 'sarah.johnson@company.com',
    role: 'credit-controller',
  },
  {
    id: 'user-002',
    name: 'Mike Chen',
    initials: 'MC',
    email: 'mike.chen@company.com',
    role: 'credit-controller',
  },
  {
    id: 'user-003',
    name: 'Emily Rodriguez',
    initials: 'ER',
    email: 'emily.rodriguez@company.com',
    role: 'credit-controller',
  },
  {
    id: 'user-004',
    name: 'David Kim',
    initials: 'DK',
    email: 'david.kim@company.com',
    role: 'credit-controller',
  },
  {
    id: 'user-005',
    name: 'Lisa Anderson',
    initials: 'LA',
    email: 'lisa.anderson@company.com',
    role: 'credit-controller',
  },
  {
    id: 'user-006',
    name: 'James Wilson',
    initials: 'JW',
    email: 'james.wilson@company.com',
    role: 'credit-controller',
  },
];
